package com.arena_web.domain.usecases.auth

import com.arena_web.data.dto.RefreshTokenRequest
import com.arena_web.data.dto.RefreshTokenResponse
import com.arena_web.domain.repositories.AuthRepository
import com.arena_web.utils.Storage
import com.arena_web.utils.StorageKeys

class RefreshTokenUseCase(private val authRepository: AuthRepository) {

    suspend operator fun invoke(): Result<RefreshTokenResponse> {
        val refreshToken = Storage.get(StorageKeys.REFRESH_TOKEN)
            ?: return Result.failure(Exception("No refresh token found"))

        val result = authRepository.refresh(RefreshTokenRequest(refreshToken))
        result.onSuccess {
            Storage.save(StorageKeys.ACCESS_TOKEN, it.accessToken)
            Storage.save(StorageKeys.REFRESH_TOKEN, it.refreshToken)
        }
        return result
    }
}
